export const getScores = (data, key) => {
  /* Function can be used for getting any object key-value.
  In our case it is used to return the scores, rankscores, etc. 
  data input is an object and the return value is always an array.
  data?.[key] !== "number" is needed for number value equal to 0 */
  if (
    !data ||
    !Object.keys(data).length ||
    (!data?.[key] && typeof data?.[key] !== "number")
  )
    return [];
  return Array.isArray(data[key]) ? data[key] : [data[key]];
};

export const getScoresArray = (data, key) => {
  /* Function used for getting the scoresArray of objects.
  data input is an object and the return value is always an array of objects. */
  if (
    !data ||
    !Object.keys(data).length ||
    (!data?.[key] && typeof data?.[key] !== "number") ||
    (Array.isArray(data?.[key]) &&
      data?.[key].every((element) => element === null))
  )
    return [];

  const transcripts = data?.ensembl_transcriptid;
  const scores = Array.isArray(data[key]) ? data[key] : [data[key]];
  let scoresArray = [];
  if (scores?.length > 1) {
    if (scores?.length === transcripts?.length) {
      scoresArray = scores.map((score, i) => {
        return { score, transcript: transcripts?.[i] };
      });
      return scoresArray;
    }
    scoresArray = scores.map((score) => {
      return { score, transcript: null };
    });
    return scoresArray;
  }

  scoresArray.push({ score: scores, transcript: null });

  return scoresArray;
};
